T1 = {
    add2: function () {
        var IDPrintMessage = '#sTaskT1Add';

        S.printMessage(IDPrintMessage, 'hide');

        var channel = S.val('#iTaskT1Channel');
        var gReCaptchaResponse = S.val('#g-recaptcha-response');

        var btn = S.createAnimationButton('#bTaskT1Add');

        S.startAnimationButton(btn);

        S.ajax('tasks/t1/add2', {
            channel: channel,
            g_recaptcha_response: gReCaptchaResponse
        }, function (data) {
            try {
                grecaptcha.reset();

                if (data.error) {
                    switch (data.error.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'error', S.messagesJoin(data.error.data.messages));
                            break;
                        }

                        default: {
                            S.unknownErrorCode(data);
                        }
                    }
                }
                else if (data.success) {
                    switch (data.success.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'success', S.messagesJoin(data.success.data.messages));
                            break;
                        }

                        default: {
                            S.unknownSuccessCode(data);
                        }
                    }
                }
            }
            catch (e) {
                S.log(e);
            }
        }, function () {
            S.stopAnimationButton(btn);
        });
    }
};
